import { __ } from '@wordpress/i18n'

export default { readMoreLabel: __('Mehr erfahren', 'dhsv_theme') }
